// import axios from "axios";

let attempts = 0;
let fields = [
    "Child's Name",
    "School Code",
    "Grade",
]


var klaviyo_submit_btn;
var klaviyo_email_field;
var klaviyo_school_field;
var klaviyo_form_element;
var error_msg;

const getKlaviyoElements = (callback) => {
    let all_fields_found = (klaviyo_email_field && klaviyo_form_element && klaviyo_submit_btn && klaviyo_school_field);

    if ( !all_fields_found ) {
        klaviyo_form_element = document.querySelector('#klaviyo-form');
        klaviyo_email_field = klaviyo_form_element.querySelector("#email_address");
        klaviyo_school_field = klaviyo_form_element.querySelector("#school_name");
        klaviyo_submit_btn = klaviyo_form_element.querySelector("#klaviyosubmit");
        
        all_fields_found = (klaviyo_email_field && klaviyo_form_element && klaviyo_submit_btn && klaviyo_school_field);
    }
    
    if ( !all_fields_found ) {
        setTimeout(() => {
            //console.log("Could not find klaviyo fields", klaviyo_form_element,klaviyo_email_field,klaviyo_school_field,klaviyo_submit_btn);
            getKlaviyoElements(callback);
        }, 500);
    } else {
        if (callback) callback();
    }
}

const fillEmail = () => {
    klaviyo_email_field.value = window._L_SCEMAIL || '';
    try {
        let event = new Event('input', {
            bubbles: true,
            cancelable: true,
        });
        klaviyo_email_field.dispatchEvent(event);
    } catch {
        let event = document.createEvent('Event');
        event.initEvent('input', true, true);

        klaviyo_email_field.dispatchEvent(event);

    }
    if (klaviyo_email_field.value !== '') {
        // klaviyo_email_field.style = 'pointer-events: none;';
    }
}


var school_codes = [
    'TAQS-0001',
    'AHBS-0002',
    'AALF-0003',
    'AMBZ-0004',
    'BSAK-0005',
    'DESC-0006',
    'DESS-0007',
    'DGPS-0008',
    'FGIS-0009',
    'HLIS-0010',
    'MWIS-0011',
    'NBIS-0012',
    'NAIS-0013',
    'RHBS-0014',
    'RGSG-0015',
    'VHPS-0016',
    'SISM-0017',
    'TEC-0018',
    'ACSAD-0019',
    'SISAT-0020',
    'SISAQ-0021',
    'AAS-0022',
    'AS-0023',
    'DESS-0024',
    'IAS-0025',
    'DGPS-0026'
];

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
        getKlaviyoElements(() => {
            fillEmail();
            error_msg = document.createElement('div');
            error_msg.classList.add('w-full');
            error_msg.style="color: #ee0000";
            klaviyo_submit_btn.parentElement.insertBefore(error_msg, klaviyo_submit_btn.nextSibling);
            error_msg.parentElement.classList.add('flex-wrap');
            klaviyo_school_field.addEventListener('input', function(event) {
                if (klaviyo_school_field.value === '') {
                    error_msg.innerHTML = '';
                    return;
                }
                let codes = klaviyo_school_field.value.split(',');
                let all_codes_valid = true;
                codes.forEach(code => {
                    if (!school_codes.includes(code)) all_codes_valid = false;
                })
                if (!all_codes_valid ) {
                    error_msg.innerHTML = "That's not a valid school code.";
                    klaviyo_submit_btn.disabled = true;
                } 
                else {
                    error_msg.innerHTML = '';
                    klaviyo_submit_btn.disabled = false;
                }
            });
        })
    }, 250);

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));


    document.querySelector('#klaviyo-form').addEventListener("submit", async function(e) { 
        e.preventDefault();
        // console.log("SUBMIT", e);
        // Disable the submit button
        document.querySelector("#klaviyosubmit").disabled = true;

            
        let payload = {
            customer_id: window._L_SCID,
            child_name: document.querySelector('#childs_name').value,
            school_name: document.querySelector('#school_name').value,
            school_grade: document.querySelector('#grade').value,
            email: document.querySelector('#email_address').value
        }

        console.log('Sending payload: ', payload)
    
        let response  = await fetch('https://trutex.little.build/api/customer/info?api_key=gJPue3bqYVo7Eqf7Q8mQsOpdjR5UlhY5Px2yDqUUCpVbJOrzaWsSW', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                },
            body: JSON.stringify(payload)
        });      

        console.log('Response data: ', response.data)
        
        if(response.ok){
            console.log('Success');

            const data = {
                customer_id: payload.customer_id,
                school_code: payload.school_name
            }
            console.log('Sending data to our app: ', data)

            const res  = await fetch('https://prod.trutex.ae/customers/assign', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    },
                body: JSON.stringify(data)
            });      
            console.log('Response: ', res.data)
            window.location.href = '/pages/register'
        }else{
            // The form submission failed so re-enable the button
            document.querySelector("#klaviyosubmit").disabled = false;
            console.log('Error in sending info to Klaviyo.')
        }

        window.__klaviyo_data = payload;
        let button = document.getElementById('hidden-shop-now-button');
        button.classList.remove('hidden');
    });
});

